import { useMemo } from "react";
import { useSelector } from "react-redux";

import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import { useAssets } from "../../../../reactQuery/domainAssets";
import { useUsers } from "../../../../reactQuery/users";
import { getUserRows } from "../utils/userManagementUtils";
import { getResponseData } from "../../../../reactQuery/response";

export function useUserManagementTable() {
  const [userType] = useCustomSearchParams("users-type");
  const [userStatus] = useCustomSearchParams("users-status");
  const { isLoading, error, users, isError } = useUsers();
  const searchText = useSelector((state) => state.search.searchText);
  const { icon } = useAssets();
  const userData = useMemo(
    () => getResponseData(users,[]),
    [users]
  );

  const rows = useMemo(() => {
    return getUserRows(userData, searchText, userType, userStatus);
  }, [searchText, userData, userStatus, userType]);

  return {
    rows,
    icon,
    isLoading,
    error,
    isError,
  };
}
